import { CheckCircle } from "lucide-react";

export const ThankYouSection = ({ data }: any) => {
    return (
        <div className="py-20 px-4 text-center container mx-auto">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
            <h1 className="text-4xl font-bold mb-4">{data?.title || "Thank You!"}</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">{data?.message || "Your order has been received successfully."}</p>
        </div>
    );
};
